module.exports = __webpack_public_path__ + "img/knight3_03.3d00e7e9.jpg";